import React from 'react'
import ReactDOM from 'react-dom/client'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import ErrorHandler from './components/ErrorBoundaryFallBack/ErrorHandler'
import { loadConfig, getConfig } from './config'
import App from './App'
import './index.css'

loadConfig().then(() => {
  const config = getConfig()

  let AppTree

  if (config?.bugsnagKey) {
    Bugsnag.start({
      apiKey: config.bugsnagKey,
      plugins: [new BugsnagPluginReact()],
    })

    const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

    AppTree = (
      <ErrorBoundary FallbackComponent={ErrorHandler}>
        <App />
      </ErrorBoundary>
    )
  } else {
    AppTree = <App />
  }

  const root = ReactDOM.createRoot(document.getElementById('root'))

  root.render(<React.StrictMode>{AppTree}</React.StrictMode>)
})
